import React from "react";
import { university } from "../../components";

const Compare = () => {
  return <university.Compare />;
};

export default Compare;
